<template>
  <section>
    <Header :user="user" />
    <main
      class="main animated fadeIn faster"
      :class="{ 'expand-main': isMenuCollapse }"
    >
      <div class="row">
        <div class="col-md-12">
            <EmailSyncList />
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import EmailSyncList from "@/components/Agencies/EmailSyncList.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "SyncEmails",
  components: {
    EmailSyncList,
  },
  mounted() {
    this.setInfoHeader();
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },
  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },

    setInfoHeader() {
      switch (parseInt(this.$route.params.item)) {
        case 29:
          this.$emit(
            "updateHeader",
            "Running orders from active customers whose variation in Meeting / single prospect (global) is greater than or equal to -20% and who have no prospecting emails warming up or active for less than 10 days."
          );
          break;
        case 28:
          this.$emit(
            "updateHeader",
            "Phone lookup : This shows all received emails that potentially contain contact phone numbers."
          );
          break;
        case 27:
          this.$emit(
            "updateHeader",
            "Burned domain : An order appears on this list if its domain has been prospecting for at least 30 days with 0% deliverability on both Gmail and Outlook."
          );
          break;
        case 26:
          this.$emit(
            "updateHeader",
            "Client attribution : Each client must be linked to a sale. Unlinked client names appear on this list."
          );
          break;
        case 24:
          this.$emit(
            "updateHeader",
            "Running orders with available contacts and the 'Create mailboxes' option enabled that haven't sent any emails in the last 3 business days appear on this list"
          );
          break;
        case 22:
          this.$emit(
            "updateHeader",
            "When Oliverlist cannot access an email address due to SMTP authentication failure or other access errors, the error code message appears."
          );
          break;
        case 17:
          this.$emit(
            "updateHeader",
            "If an active order's sale has no linked emails, the order name appears on this list."
          );
          break;
        case 16:
          this.$emit(
            "updateHeader",
            "An email appears on this list if it's linked to an active sale but isn't connected to Warmy or if the warmup isn't activated"
          );
          break;
        case 14:

          if(this.$route.params.status == '1'){
            this.$emit(
            "updateHeader",
            "Orders that are not in the WAC list and for which the 3D AVG First Contact % index is less than 80%. 3D AVG First Contact % being the level of objective met in terms of new contact engagement in the order, based on the objectives set in the order and the number of prospecting emails assigned to it."
          );

          } else if (this.$route.params.status == '2'){
            this.$emit(
            "updateHeader",
            "Orders that are not in the WAC list and for which the 3D AVG First Contact % index is between 11% and 60%. 3D AVG First Contact % being the level of objective met in terms of new contact engagement in the order, based on the objectives set in the order and the number of prospecting emails assigned to it."
          );
          }
          
          break;
        case 13:
          this.$emit(
            "updateHeader",
            "If variables are incorrectly inserted in an order's copywriting, the order name appears on this list until corrected."
          );
          break;
        case 12:
          this.$emit(
            "updateHeader",
            "When an order is confirmed, we receive a request to purchase a new domain. The request remains on this list until the domain is bought."
          );
          break;
        case 8:
          this.$emit(
            "updateHeader",
            "After purchasing a domain, it requires manual configuration. The system checks for DMARC, SPF, and DKIM in the DNS configuration. The domain stays on the list until these are present."
          );
          break;
        case 6:
          this.$emit(
            "updateHeader",
            "When Oliverlist cannot access an email address due to SMTP authentication failure: For Microsoft emails, access must be enabled in the email inbox settings. For Google accounts, enable less secure app authentication and two-step verification, then generate a passkey and add it to the SMTP Excel file for Pablo to update the email access"
          );
          break;
        case 5:
          this.$emit(
            "updateHeader",
            "After a domain is purchased, new emails will briefly appear on this list. If they remain stuck, it indicates either an issue with the generation process (requiring Wences to be notified) or insufficient licenses in the corresponding workspace."
          );
          break;
          case 3:
          this.$emit(
            "updateHeader",
            "Google or Microsoft may block emails. When blocked, the email appears on this list. It must be manually unblocked in the restricted entities of the corresponding workspace."
          );
          break;
          case 2:
          this.$emit(
            "updateHeader",
            "Sometimes emails get disconnected from the Oliverlist platform. When this happens, they appear on this list for reconnection."
          );
          break;
          case 1:
            
          this.$emit(
            "updateHeader",
            "Once an email has been generated, it needs to be connected to the Oliverlist platform. If not connected, it will appear on this list"
          );
          break;
        default:
          break;
      }
    },
  },
};
</script>
